/* Global Free Shipping Bar - Logic
  - Fetches threshold from DOM (data attributes).
  - Intercepts Fetch and XHR to detect cart changes automatically.
  - Formats currency using browser native Intl API.
*/

// --- CORE LOGIC ---

function getThreshold() {
  const bar = document.querySelector('[data-free-shipping-bar]');
  if (!bar) return 0;
  const attr = bar.getAttribute('data-free-shipping-threshold');
  const parsed = parseInt(attr, 10);
  return (Number.isFinite(parsed) && parsed > 0) ? parsed : 0;
}

function getLang() {
  const bar = document.querySelector('[data-free-shipping-bar]');
  return bar ? bar.getAttribute('data-current-lang') || 'en' : 'en';
}

function getDoneText(lang) {
  if (lang.startsWith('cs')) return 'Máte nárok na dopravu zdarma!';
  if (lang.startsWith('sk')) return 'Máte nárok na dopravu zdarma!';
  if (lang.startsWith('pl')) return 'Masz darmową dostawę!';
  if (lang.startsWith('de')) return 'Ihr Versand ist kostenlos!';
  return 'You have free shipping!';
}

function formatMoney(cents, currencyCode, locale) {
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(cents / 100);
}

function updateGlobalFreeShippingBar() {
  const bar = document.querySelector('[data-free-shipping-bar]');
  const textEl = document.querySelector('[data-free-shipping-text]');
  const fill = document.querySelector('[data-free-shipping-fill]');

  if (!bar || !fill || !textEl) return;

  const threshold = getThreshold();
  const currentLang = getLang();

  // Configuration safety check
  if (threshold === 0) {
    fill.style.width = '0%';
    return;
  }

  // Fetch fresh cart data
  fetch('/cart.js?_=' + Date.now()) // Cache-busting
    .then(r => r.json())
    .then(cart => {
      const total = cart.total_price;
      const remainingCents = threshold - total;
      
      let percentage = (total / threshold) * 100;
      
      // Visual Logic
      if (percentage > 100) percentage = 100;
      if (percentage < 0) percentage = 0;
      if (total > 0 && percentage < 5) percentage = 5; // Min visible width
      if (total === 0) percentage = 0;

      fill.style.width = percentage + '%';

      if (remainingCents > 0) {
        // If the text was previously replaced by "Done", we must restore the HTML structure
        if (!textEl.querySelector('[data-free-shipping-amount]')) {
           restoreBaseText(textEl, currentLang);
        }
        
        const amountEl = textEl.querySelector('[data-free-shipping-amount]');
        if (amountEl) {
          amountEl.textContent = formatMoney(remainingCents, cart.currency, currentLang);
        }
      } else {
        textEl.textContent = getDoneText(currentLang);
      }
    })
    .catch(err => console.error('[FSB] Error fetching cart:', err));
}

function restoreBaseText(container, lang) {
  let html = '';
  if (lang.startsWith('cs')) html = 'Zbývá <span data-free-shipping-amount></span> do dopravy zdarma.';
  else if (lang.startsWith('sk')) html = 'Zostáva <span data-free-shipping-amount></span> do dopravy zdarma.';
  else if (lang.startsWith('pl')) html = 'Pozostało <span data-free-shipping-amount></span> do darmowej dostawy.';
  else if (lang.startsWith('de')) html = 'Es fehlen noch <span data-free-shipping-amount></span> bis zum kostenlosen Versand.';
  else html = '<span data-free-shipping-amount></span> left for free shipping.';
  container.innerHTML = html;
}

// --- NETWORK INTERCEPTORS (The Fix) ---

function initNetworkInterceptors() {
  // 1. Intercept standard Fetch API (used by most modern themes)
  const originalFetch = window.fetch;
  window.fetch = function () {
    return originalFetch.apply(this, arguments).then((response) => {
      // Check if the request URL is related to the cart
      const url = arguments[0];
      if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update'))) {
        // Wait slightly for Shopify DB to sync, then update
        setTimeout(updateGlobalFreeShippingBar, 100);
      }
      return response;
    });
  };

  // 2. Intercept XMLHttpRequest (used by older themes/apps)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function() {
    this.addEventListener('load', function() {
      if (this.responseURL && (this.responseURL.includes('/cart/add') || this.responseURL.includes('/cart/change') || this.responseURL.includes('/cart/update'))) {
        setTimeout(updateGlobalFreeShippingBar, 100);
      }
    });
    origOpen.apply(this, arguments);
  };
}

// --- INIT ---

document.addEventListener('DOMContentLoaded', () => {
  updateGlobalFreeShippingBar();
  initNetworkInterceptors();
});

// Fallback: Listen for standard Shopify custom events just in case
document.addEventListener('cart:updated', updateGlobalFreeShippingBar);
document.addEventListener('cart:add', updateGlobalFreeShippingBar);